export default {"src":"/_next/static/media/grammar-school-icon.5c60321d.svg","height":14,"width":15,"blurWidth":0,"blurHeight":0};